/**
 * Handles the visibility and behavior of the sticky header for the NOC variant.
 */
export const initNocStickyHeader = (): void => {
  const stickyBar = document.querySelector<HTMLElement>(".header-noc__sticky");

  if (!stickyBar) {
    return;
  }

  // The point at which the sticky header appears.
  // 400px ensures the original header is completely out of view.
  const scrollThreshold = 400;

  let isStickyActive = false;

  const toggleStickyHeader = () => {
    const shouldBeActive = window.scrollY > scrollThreshold;

    if (shouldBeActive !== isStickyActive) {
      isStickyActive = shouldBeActive;

      if (isStickyActive) {
        stickyBar.classList.add("is-visible");
      } else {
        stickyBar.classList.remove("is-visible");
      }
    }
  };

  // Add listener with passive: true for scroll performance optimization
  window.addEventListener("scroll", toggleStickyHeader, { passive: true });

  // Check initial position in case of page refresh while scrolled down
  toggleStickyHeader();

  console.log("[StickyHeaderNoc] Initialized.");
};
